export default __webpack_public_path__ + "static/media/Zinger ERP.0e493803.png";